/**
 * ===========================
 * MAIN
 * ===========================
 */

import { BASE_URL } from '@apps/config';
import { getEvTest } from '@apps/config/API/new-car.config';
import { EvTestScreen } from '@apps/screens/EvTest';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { NextSeo, NextSeoProps } from 'next-seo';

const Page: NextPage = (props) => {
  const { data, webView = false } = props;
  // ======================= HOOKS
  const router = useRouter();
  // const { t } = useTranslation('common');

  // ======================= STATE

  // ======================= VARIABLES
  const currentUrl = `${BASE_URL}${router?.asPath}`;
  const canonicalPath = currentUrl.split('?')[0].toLowerCase();
  const nextSeoProps: NextSeoProps = {
    defaultTitle:
      'EV Car Testing & Reviews in Malaysia: Performance, Safety & More | Carz Automedia Malaysia',
    description:
      'Dive into detailed EV car testing and reviews in Malaysia. Learn about electric vehicle performance, range, charging, safety, technology, and comfort with Carz Automedia Malaysia’s in-depth evaluations.',
    canonical: canonicalPath,
  };

  // ======================= VIEWS
  return (
    <>
      {!webView && <NextSeo {...nextSeoProps} />}
      <EvTestScreen {...data} webView={webView} />
    </>
  );
};

/**
 * ===========================
 * SERVER SIDE RENDERING
 * ===========================
 */

Page.layout = 'customContainer';

export async function getServerSideProps() {
  const data = await getEvTest();

  return {
    props: {
      data,
    },
  };
}

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
